/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationPreferenceDtoFromJSON, NotificationPreferenceDtoToJSON, } from './NotificationPreferenceDto';
/**
 * Check if a given object implements the NotificationPreferencesDto interface.
 */
export function instanceOfNotificationPreferencesDto(value) {
    let isInstance = true;
    return isInstance;
}
export function NotificationPreferencesDtoFromJSON(json) {
    return NotificationPreferencesDtoFromJSONTyped(json, false);
}
export function NotificationPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'preferences': !exists(json, 'preferences') ? undefined : (json['preferences'] === null ? null : json['preferences'].map(NotificationPreferenceDtoFromJSON)),
    };
}
export function NotificationPreferencesDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'preferences': value.preferences === undefined ? undefined : (value.preferences === null ? null : value.preferences.map(NotificationPreferenceDtoToJSON)),
    };
}
